import React, { PureComponent } from 'react';
import ReactImageZoom from 'react-image-zoom';
import Carousel from '../../../Carousel/Carousel';
import LKModal from '../../../Modal/Modal';
import './ImageZoom.scss';

class ImageZoom extends PureComponent {
  static propTypes = {};
  constructor(props, context) {
    super(props, context);
    this.state = {
      showModal: true,
      modalImageIndex: props.modalImageIndex,
      isImageLoaded: true,
    };
    this.setImageWidthHeight = this.setImageWidthHeight.bind(this);
    // this.showZoomModal = this.showZoomModal.bind(this);
    // this.carouselConfig = {
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   fade: true,
    //   lazyLoad: true,
    //   autoplay: false,
    //   afterChange: newIndex => {
    //     this.setState({ modalImageIndex: newIndex }, () => {
    //       const imgToLoad = [];
    //       if (
    //         this.state.modalImageIndex ===
    //         this.props.processedImage.length - 1
    //       ) {
    //         imgToLoad.push(
    //           this.props.processedImage[0].mediumImg,
    //           this.props.processedImage[this.state.modalImageIndex - 1]
    //             .mediumImg
    //         );
    //       } else if (this.state.modalImageIndex === 0) {
    //         imgToLoad.push(
    //           this.props.processedImage[this.props.processedImage.length - 1]
    //             .mediumImg,
    //           this.props.processedImage[this.state.modalImageIndex + 1]
    //             .mediumImg
    //         );
    //       } else {
    //         imgToLoad.push(
    //           this.props.processedImage[newIndex + 1].mediumImg,
    //           this.props.processedImage[newIndex - 1].mediumImg
    //         );
    //       }
    //       props.loadImage(null, imgToLoad);
    //     });
    //   }
    // };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setImageWidthHeight();
    }, 0);
    window.addEventListener('resize', this.setImageWidthHeight);
  }

  componentDidUpdate(prevProps) {
    if (this.props.modalImageIndex !== prevProps.modalImageIndex) {
      // this.setState({ isImageLoaded: false });
      this.setImageWidthHeight();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setImageWidthHeight);
  }

  getZoomRef = ref => {
    this.zoomRef = ref;
  };

  setImageWidthHeight() {
    const id = document.getElementById('zoom-image-container');
    if (id) {
      const image = id.children[0].children[0];
      this.setState({ zoomImgWidth: id.children[0].offsetWidth });
      if (!image.complete) {
        this.setState({ isImageLoaded: false });
      }
      image.onload = () => {
        this.setState({ isImageLoaded: true });
      };
    }
  }

  updatedCarouselData() {
    this.processedData = null;
    this.processedData = this.props.processedImage.map((banner, index) => {
      return (
        <div key={`carousel-category${index}${banner.img}`} className="catSlider_carouselItem">
          <img
            alt={banner.label}
            className="sliderImg"
            src={banner.mediumImg}
            title={banner.label}
          />
        </div>
      );
    });
  }

  // showZoomModal() {
  //   const zoomprop = { ...this.props.zoomProps };
  //   this.carouselConfig = Object.assign({}, this.carouselConfig, {
  //     initialSlide: zoomprop.index
  //   });
  //   this.setState({ showModal: true, modalImageIndex: zoomprop.index });
  // }

  hideModal() {
    const { hideModal } = this.props;
    this.setState({ showModal: false });
    hideModal();
  }

  changeCarouselSlide(index) {
    if (this.props.modalImageIndex !== index) {
      const { changeCarouselSlide } = this.props;
      changeCarouselSlide(index);
    }
  }

  modalBody() {
    const {
      zoomProps,
      processedImage,
      dataLocale: { LOADER, CLOSE },
    } = this.props;
    const { modalImageIndex, zoomImgWidth, isImageLoaded } = this.state;
    const carouelResponsiveSettings = [
      { breakpoint: 1500, settings: { slidesToShow: 6 } },
      { breakpoint: 1024, settings: { slidesToShow: 5 } },
      { breakpoint: 600, settings: { slidesToShow: 5 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
    ];
    return (
      <>
        <div style={{ direction: 'rtl' }}>
          <img
            alt={CLOSE}
            className="cursor-pointer"
            data-testid="closeModal"
            src="/assets/svg/Cross.svg"
            onClick={() => this.hideModal()}
          />
        </div>
        <div style={{ padding: '0px 60px', height: 'auto', width: '100%' }}>
          {isImageLoaded ? (
            <div
              id="zoom-image-container"
              style={{
                minHeight: '350px',
                width: '100%',
                // backgroundImage:
                //   'url("https://static.lenskart.com/media/desktop/img/loader-lk.gif")',
              }}
            >
              <ReactImageZoom ref={this.zoomRef} {...zoomProps} width={zoomImgWidth} />
            </div>
          ) : (
            <div style={{ height: 'auto', width: '100%' }}>
              <img
                alt={LOADER}
                src="https://static.lenskart.com/media/desktop/img/loader-lk.gif"
                style={{ zIndex: '10', width: zoomImgWidth }}
              />
            </div>
          )}
          <div className="par" style={{ marginTop: '30px', paddingBottom: '30px' }}>
            <Carousel
              // carouselConfig={this.carouselConfig}
              carouselList={processedImage}
              carouselStyle="custom-zoom-image"
              changeCarouselSlide={value => this.changeCarouselSlide(value)}
              imageKey="smImg"
              initialSlide={modalImageIndex}
              responsive={carouelResponsiveSettings}
            />
          </div>
        </div>
      </>
    );
  }

  render() {
    const { test } = this.props;
    this.updatedCarouselData();

    return (
      <div className="product-image-zoom">
        {this.state.showModal && (
          <div className="modal-image-carousel" style={{ paddingBottom: '30px' }}>
            {test && this.modalBody()}
            <LKModal
              backdrop
              keyboard
              dialogClassName="padding-0 lkModal modal-width"
              hideHandler={() => this.hideModal()}
              showModal={this.state.showModal}
              size="large"
            >
              {!test && this.modalBody()}
            </LKModal>
          </div>
        )}
      </div>
    );
  }
}
export default ImageZoom;
